import React, { useEffect, useState } from "react";
import logo from "../assets/Telurmix2.png";
import { MDBListGroup, MDBListGroupItem, MDBIcon } from "mdbreact";
import { NavLink } from "react-router-dom";

import iconTonovani from "../images/buttons/tonovani.png";
import iconReceptury from "../images/buttons/receptura.png";
import iconVlastniReceptury from "../images/buttons/receptura.png";
import iconKopirovaniReceptur from "../images/buttons/receptura.png";
import iconExportReceptur from "../images/buttons/exportreceptur.png";
import iconVyrobky from "../images/buttons/vyrobky.png";
import iconBaze from "../images/buttons/baze.png";
import iconBaleni from "../images/buttons/skladbazi.png";
import iconPigmenty from "../images/buttons/pigmenty.png";
import iconVzorkovnice from "../images/buttons/vzorky.png";
import iconOdstiny from "../images/buttons/odstin.png";
import iconCenik from "../images/buttons/cenikproduktu.png";
import iconExport from "../images/buttons/export.png";

import "./navigation.css";
import { useSelector } from "react-redux";
import { checkAdditionalRole, checkCrud } from "../helpers/userRolesHelper";
import SideNavigationItem from "./SideNavigationItem";
import { useTranslation } from "react-i18next";

interface Props {
  onToggle: any;
}

const SideNavigation = (props: Props) => {
  const { t } = useTranslation();
  const [canBasis, setCanBasis] = useState(false);
  const [canToning, setCanToning] = useState(false);
  const [canReceipt, setCanReceipt] = useState(false);
  const [canReceiptAdmin, setCanReceiptAdmin] = useState(false);
  const [canProduct, setCanProduct] = useState(false);
  const [canPackage, setCanPackage] = useState(false);
  const [canHardener, setCanHardener] = useState(false);
  const [canPigment, setCanPigment] = useState(false);
  const [canSampleCard, setCanSampleCard] = useState(false);
  const [canColor, setCanColor] = useState(false);
  const [canSeller, setCanSeller] = useState(false);
  const [canUser, setCanUser] = useState(false);
  const [canDiscount, setCanDiscount] = useState(false);
  const [canCopyReceipt, setCanCopyReceipt] = useState(false);
  const [canCustomReceipts, setCanCustomReceipts] = useState(false);

  const [isHidden, setIsHidden] = useState(false);

  const userInfo = useSelector((state: any) => state.userInfo);

  useEffect(() => {
    if (userInfo) {
      setCanBasis(checkCrud('base', 'read', userInfo));
      setCanToning(checkCrud('toning', 'read', userInfo));
      setCanReceipt(checkCrud('receipt', 'read', userInfo));
      setCanReceiptAdmin(checkCrud('receipt', 'admin', userInfo));
      setCanProduct(checkCrud('product', 'read', userInfo));
      setCanPackage(checkCrud('package', 'read', userInfo));
      setCanHardener(checkCrud('hardener', 'read', userInfo));
      setCanPigment(checkCrud('pigment', 'read', userInfo));
      setCanSampleCard(checkCrud('sampleCard', 'read', userInfo));
      setCanColor(checkCrud('color', 'read', userInfo));
      setCanSeller(checkCrud('seller', 'read', userInfo));
      setCanUser(checkCrud('user', 'read', userInfo));
      setCanDiscount(checkCrud('discount', 'read', userInfo));
      setCanCopyReceipt(checkAdditionalRole('copyReceipt', userInfo));
      setCanCustomReceipts(checkAdditionalRole('customReceipts', userInfo));
    }
  }, [userInfo]);

  const hangleToggle = () => {
    setIsHidden(!isHidden);
    props.onToggle();
  }

  return (
    <div className={isHidden ? "sidebar-fixed position-fixed hidden" : "sidebar-fixed position-fixed"}>
      <div className="logo">
        <a href="#!" className="logo-wrapper waves-effect">
          <img style={{ paddingTop: 0, paddingBottom: 0 }} src={logo} />
        </a>
        <i onClick={hangleToggle} className={isHidden ? "toggler fas fa-angle-double-right" : "toggler fas fa-angle-double-left"}></i>

      </div>


      <MDBListGroup className="list-group-flush">
        <SideNavigationItem
          label={t('Toning.Label')}
          link={'/tonovani'}
          icon={iconTonovani}
          hasAccess={canToning}
        />
        <SideNavigationItem
          label={t('Receipts.Label')}
          link={'/receptury'}
          icon={iconReceptury}
          hasAccess={canReceiptAdmin}
        />

        <SideNavigationItem
          label={t('Receipts.LabelCustom')}
          link={'/vlastnireceptury'}
          icon={iconReceptury}
          hasAccess={canCustomReceipts}
        />
        {/*
        <NavLink to="/__recepturyvlastni" activeClassName="activeClass">
          <MDBListGroupItem className="disabledElementWithOpacity">
            <img src={iconVlastniReceptury} className="mr-3" />
            {t('CustomReceipts.Label')}
          </MDBListGroupItem>
        </NavLink>
  */}
        <SideNavigationItem
          label={t('CopyReceipts.Label')}
          link={'/kopirovanireceptur'}
          icon={iconKopirovaniReceptur}
          hasAccess={canCopyReceipt}
        />
        {/*
        <NavLink to="/__recepturyexport" activeClassName="activeClass">
          <MDBListGroupItem className="disabledElementWithOpacity">
            <img src={iconExportReceptur} className="mr-3" />
            {t('ExportReceipts.Label')}
          </MDBListGroupItem>
        </NavLink>
  */}
        <SideNavigationItem
          label={t('Products.Label')}
          link={'/products'}
          icon={iconVyrobky}
          hasAccess={canProduct}
        />
        <SideNavigationItem
          label={t('Bases.Label')}
          link={'/baze'}
          icon={iconBaze}
          hasAccess={canBasis}
        />
        <SideNavigationItem
          label={t('Packages.Label')}
          link={'/baleni'}
          icon={iconBaleni}
          hasAccess={canPackage}
        />
        <SideNavigationItem
          label={t('Hardeners.Label')}
          link={'/tuzidla'}
          icon={iconBaleni}
          hasAccess={canHardener}
        />
        <SideNavigationItem
          label={t('Pigments.Label')}
          link={'/pigmenty'}
          icon={iconPigmenty}
          hasAccess={canPigment}
        />
        <SideNavigationItem
          label={t('Samplecards.Label')}
          link={'/vzorkovnice'}
          icon={iconVzorkovnice}
          hasAccess={canSampleCard}
        />
        <SideNavigationItem
          label={t('Colors.Label')}
          link={'/odstiny'}
          icon={iconOdstiny}
          hasAccess={canColor}
        />
        {/*
        <NavLink to="/__cenik" activeClassName="activeClass">
          <MDBListGroupItem className="disabledElementWithOpacity">
            <img src={iconCenik} className="mr-3" />
            {t('PriceList.Label')}
          </MDBListGroupItem>
        </NavLink>
*/}
        {/*
        <NavLink to="/__export" activeClassName="activeClass">
          <MDBListGroupItem className="disabledElementWithOpacity">
            <img src={iconExport} className="mr-3" />
            Export
          </MDBListGroupItem>
        </NavLink>
  */}
      </MDBListGroup>
      <div className="systemVersion" style={{ textAlign: 'center', margin: '10px', fontWeight: 'bold' }}>
        verze: 1.07
      </div>
    </div>
  );
};

export default SideNavigation;
